module.exports = __webpack_public_path__ + "static/img/t15.451834d5.png";